import React from 'react';
import MediaQuery from 'react-responsive/src/Component';
import PastEvents from 'components/organisms/pastEvents';
import PastEventsMobile from 'components/organisms/pastEventsMobile';

const PastEventsSection = props => {
  return (
    <div id={'past-events'}>
      <MediaQuery maxDeviceWidth={575.6}>
        <PastEventsMobile
          data={props.data}
          pastEventsIntro={props.data.pastEventsIntro}
          pastEvents={props.data.pastEvents}
        />
      </MediaQuery>
      <MediaQuery minDeviceWidth={576}>
        <PastEvents
          pastEventsIntro={props.data.pastEventsIntro}
          pastEvents={props.data.pastEvents}
          pastEventSection={props.data.pastEventSection}
        />
      </MediaQuery>
    </div>
  );
};

export default PastEventsSection;
